
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  BarChart, 
  Gift, 
  LucideIcon, 
  Menu, 
  Megaphone, 
  Settings, 
  X 
} from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

type NavItem = {
  name: string;
  href: string;
  icon: LucideIcon;
};

const navItems: NavItem[] = [
  { name: "Dashboard", href: "/admin", icon: BarChart },
  { name: "Campaigns", href: "/admin/campaigns", icon: Megaphone },
  { name: "Vouchers", href: "/admin/vouchers", icon: Gift },
  { name: "Settings", href: "/admin/settings", icon: Settings },
];

export function AdminSidebar() {
  const [expanded, setExpanded] = useState(true);
  const location = useLocation();

  return (
    <div className={cn(
      "h-screen bg-sidebar flex flex-col border-r border-sidebar-border transition-all duration-300 ease-in-out",
      expanded ? "w-64" : "w-20"
    )}>
      <div className="flex items-center justify-between p-4 h-16">
        {expanded ? (
          <h1 className="text-sidebar-foreground font-bold text-xl">BeerDrop <span className="text-beerdrop-teal">Admin</span></h1>
        ) : (
          <span className="text-sidebar-foreground font-bold text-xl mx-auto">BD</span>
        )}
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={() => setExpanded(!expanded)}
          className="text-sidebar-foreground hover:bg-sidebar-accent"
        >
          {expanded ? <X size={20} /> : <Menu size={20} />}
        </Button>
      </div>
      
      <nav className="flex-1 px-2 py-4 space-y-1">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={cn(
              "flex items-center px-4 py-3 text-sidebar-foreground rounded-md transition-colors",
              location.pathname === item.href || 
              (item.href !== "/admin" && location.pathname.startsWith(item.href))
                ? "bg-sidebar-accent text-sidebar-foreground"
                : "hover:bg-sidebar-accent/50 hover:text-sidebar-foreground"
            )}
          >
            <item.icon className="h-5 w-5" />
            {expanded && <span className="ml-3">{item.name}</span>}
          </Link>
        ))}
      </nav>
      
      <div className="p-4 flex items-center">
        {expanded ? (
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 rounded-full bg-beerdrop-purple flex items-center justify-center text-white font-bold">
              A
            </div>
            <div>
              <p className="text-sm font-medium text-sidebar-foreground">Admin User</p>
              <p className="text-xs text-sidebar-foreground/70">admin@beerdrop.com</p>
            </div>
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full bg-beerdrop-purple flex items-center justify-center text-white font-bold mx-auto">
            A
          </div>
        )}
      </div>
    </div>
  );
}
